import { render, staticRenderFns } from "./WageGap.vue?vue&type=template&id=682be84a&scoped=true&"
import script from "./WageGap.vue?vue&type=script&lang=js&"
export * from "./WageGap.vue?vue&type=script&lang=js&"
import style0 from "./WageGap.vue?vue&type=style&index=0&id=682be84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682be84a",
  null
  
)

export default component.exports